// extracted by mini-css-extract-plugin
export default {"disabled":"_1upLQs4GuPQvKxG0uamZcW"};